export function sanitizeExternalExcerpt(value) {
  const raw = String(value == null ? "" : value);
  if (!raw.trim()) return "";

  return raw
    .replace(/<\s*contact\s*>\s*[,;:|·-]?\s*/gi, " ")
    .replace(/\s+([,.;:!?])/g, "$1")
    .replace(/([,.;:!?])(?=[^\s\n])/g, "$1 ")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/ *\n */g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
